var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.getFilteredItemsCount === 0
      ? _c("p", [_vm._v(_vm._s(_vm.labels.noItemsMessage))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "columnWrapper",
        staticClass: "columnWrapper",
        class: {
          "is-grid-mode": _vm.layoutMode == "grid",
          "is-feed-mode":
            _vm.layoutMode == "feed" && _vm.galleryVersion == "modern",
        },
        attrs: { role: "list" },
      },
      [
        _c(
          "transition-group",
          { attrs: { name: "list", tag: "div", role: "list" } },
          _vm._l(_vm.galleryItems, function (item) {
            return _c("gallery-item", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.visible,
                  expression: "item.visible",
                },
              ],
              key: `item-${item.id}`,
              ref: "galleryItemElem",
              refInFor: true,
              attrs: {
                "aria-hidden": item.visible ? "false" : "true",
                id: `gallery-item-${item.id}`,
                item: item,
              },
            })
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }